import React from "react";
import PropTypes from "prop-types";
import ReportHeader from "./ReportHeader";
import { TR } from "./BusinessDashboard/Table/Table";

const AgentActivityHeaders = ({ sortBy, sortKey, sortDesc }) => (
  <TR className="tw-sticky tw-top-0 tw-bg-white">
    <ReportHeader name="agent" sortDesc={sortDesc} sortKey={sortKey} label="Name" handleSort={sortBy} />
    <ReportHeader
      name="lead_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Leads"
      className="tw-text-center"
      handleSort={sortBy}
    />

    <ReportHeader
      name="email_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Emailed"
      className="tw-text-center"
      handleSort={sortBy}
    />

    <ReportHeader
      name="call_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Called"
      className="tw-text-center"
      handleSort={sortBy}
    />
    <ReportHeader
      name="contacted_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Contacted"
      className="tw-text-center"
      handleSort={sortBy}
    />
    <ReportHeader
      name="text_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Texted"
      className="tw-text-center"
      handleSort={sortBy}
    />
    <ReportHeader
      name="email_resp_time"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Email Resp. Time"
      className="tw-text-center"
      handleSort={sortBy}
    />
    <ReportHeader
      name="call_resp_time"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Call Resp. Time"
      className="tw-text-center"
      handleSort={sortBy}
    />
    <ReportHeader
      name="text_resp_time"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Text Resp. Time"
      className="tw-text-center"
      handleSort={sortBy}
    />
    <ReportHeader
      name="login_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Logins"
      className="tw-text-center"
      handleSort={sortBy}
    />
    <ReportHeader
      name="last_login"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Last Login"
      className="tw-text-center"
      handleSort={sortBy}
    />
  </TR>
);

AgentActivityHeaders.propTypes = {
  sortBy: PropTypes.func.isRequired,
  sortKey: PropTypes.string.isRequired,
  sortDesc: PropTypes.bool.isRequired,
};

export default AgentActivityHeaders;
